"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.connectVideoStreamToVideoElement = connectVideoStreamToVideoElement;
exports.disconnectVideoStreamFromVideoElement = disconnectVideoStreamFromVideoElement;
var _DefaultVideoTile = _interopRequireDefault(require("amazon-chime-sdk-js/build/videotile/DefaultVideoTile"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/**
 * The purpose of this file is to abstract the methods and handling of the DefaultVideoTile
 * No other methods or in depth functionality should be found here
 */

function connectVideoStreamToVideoElement(videoStream, videoElement, tile) {
  _DefaultVideoTile["default"].connectVideoStreamToVideoElement(videoStream, videoElement, tile);
}
function disconnectVideoStreamFromVideoElement(videoElement) {
  _DefaultVideoTile["default"].disconnectVideoStreamFromVideoElement(videoElement);
}